import BaseService from './BaseService'

class ModifierSetService extends BaseService {
  constructor() {
    super('/modifier-sets')
  }

  async list() {
    return this.getAll()
  }

  async get(id) {
    return this.getById(id)
  }

  async createSet(payload) {
    return this.create(payload)
  }

  async updateSet(id, payload) {
    return this.update(id, payload)
  }
}

export const modifierSetService = new ModifierSetService()

